import type { ImageProps } from '@archipro-design/aria';
import { Image } from '@archipro-design/aria';
import React, { useRef, useState } from 'react';
import PaintPickerShellV1 from '~/modules/paint-picker/component/paint-picker-shell/PaintPickerShell';
import PaintPickerMobileShellV1 from '~/modules/paint-picker/component/paint-picker-shell/PaintPickerMobileShell';
import PaintPickerShellV2 from '~/modules/paint-picker-new/component/paint-picker-shell/PaintPickerShell';
import PaintPickerMobileShellV2 from '~/modules/paint-picker-new/component/paint-picker-shell/PaintPickerMobileShell';
import { useFeatureFlaggedPaintPickerContext } from '@modules/paint-picker-new/hooks/useFeatureFlaggedPaintPickerContext';

type ImageWithPaintPickerProps = ImageProps;

const ImageWithPaintPicker = (props: ImageWithPaintPickerProps) => {
    const {
        pickerContext: {
            state: {
                paintPickerActive,
                isEnabled,
                isPicking,
                activeImageSrc,
                touchEnabled,
            },
            paintSelection,
            availablePaints,
        },
        newResenePickerEnabled,
    } = useFeatureFlaggedPaintPickerContext();

    const [imageLoaded, setImageLoaded] = useState(false);
    const imageRef = useRef<HTMLImageElement | null>(null);
    const showDesktopShell =
        !touchEnabled &&
        ((!newResenePickerEnabled && paintPickerActive) ||
            (newResenePickerEnabled &&
                isEnabled &&
                availablePaints.length > 0 &&
                (isPicking || paintSelection.length < 1)));
    const showMobileShell =
        touchEnabled && paintPickerActive && activeImageSrc === props.src;

    const PaintPickerShell = newResenePickerEnabled
        ? PaintPickerShellV2
        : PaintPickerShellV1;
    const PaintPickerMobileShell = newResenePickerEnabled
        ? PaintPickerMobileShellV2
        : PaintPickerMobileShellV1;

    return (
        <>
            <Image
                {...props}
                onLoadingComplete={(result) => {
                    imageRef.current = result;
                    setImageLoaded(true);
                }}
            />
            {imageLoaded && showDesktopShell && (
                <PaintPickerShell
                    imageRef={imageRef.current}
                    imageSrc={props.src}
                />
            )}
            {showMobileShell && (
                <PaintPickerMobileShell imageRef={imageRef.current} />
            )}
        </>
    );
};

export default ImageWithPaintPicker;
